import type { FDScheme } from '@/api/models/setting/FDScheme'

/**
 * Calculates the applicable FD interest rate based on duration and age.
 *
 * @param schemes - List of FD schemes
 * @param days - Duration of the FD in days
 * @param dob - Date of birth as epoch timestamp
 * @returns Interest rate (general or senior citizen) or undefined
 */
export function fdInterestUpdate(
  schemes: FDScheme[],
  days: number,
  dob: number
): number | undefined {
  const isSenior = new Date().getFullYear() - new Date(dob).getFullYear() >= 60
  const durationYears = days / 365

  console.log(schemes)
  console.log(days)
  console.log(dob)
  for (const scheme of schemes) {
    const { endDurationType, startDurationType, startDuration, endDuration } = scheme

    const isMatch =
      (endDurationType === 'Days' && days <= endDuration) ||
      (startDurationType === 'Days' &&
        endDurationType === 'Years' &&
        days > startDuration &&
        durationYears <= endDuration) ||
      (endDurationType === 'Years' && durationYears > startDuration)

    console.log(isMatch)
    if (isMatch) {
      return isSenior
        ? (scheme.scInterestRate ?? undefined)
        : (scheme.generalInterestRate ?? undefined)
    }
  }

  return undefined
}
